import { render } from "./UserCreate.vue?vue&type=template&id=8725f478&scoped=true"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"

import "./UserCreate.vue?vue&type=style&index=0&id=8725f478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8725f478"]])

export default __exports__